import React from "react";
import { useIntl } from "react-intl";

import { Attachment } from "lib/build/attachments";
import { Event, mapEventsToAttachments, Origin } from "lib/build/events";
import { subjectMessages } from "lib/build/forms/ktx/committeeOpinion";

import { TimelineItem } from "src/common/components/Timeline";
import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useFormatName } from "src/common/hooks/useFormatName";
import { useKnownUsers } from "src/features/auth";
import { genericMessages } from "src/messages/generic";
import { PatientConditionValue } from "src/modules/ktx/status-history/types";

export function usePatientConditionTimelineItems(
	events: Event<PatientConditionValue>[]
): TimelineItem<{
	origin: Origin;
	attachments: Attachment[];
	data: PatientConditionValue;
}>[] {
	const users = useKnownUsers();
	const { formatMessage } = useIntl();
	const formatMessageMap = useFormatMessageMap();
	const formatName = useFormatName();
	return React.useMemo(
		() =>
			events.map(event => {
				const { timestamp, value, origin } = event;
				const { recordedBy: userId } = origin;
				const attachments = mapEventsToAttachments(event);
				const label =
					value.subject !== undefined
						? formatMessageMap(subjectMessages, value.subject)
						: formatMessage(
								genericMessages.medicalPractitionerComment
							);

				let author: string | undefined;
				if (userId in users) {
					author = formatName(users[userId]);
				}
				return {
					label,
					timestamp,
					author,
					value: { origin, attachments, data: value }
				};
			}),
		[events, users, formatMessage, formatMessageMap, formatName]
	);
}
